// src/services/faqService.js
import apiClient from "./apiClient";

const endpoints = { base: "/admin/faq" };

// Backend accepts "Publish" / "UnPublish"
const normalizeStatus = (s) => {
  const v = String(s || "").toLowerCase();
  return v === "publish" ? "Publish" : "UnPublish";
};

// GET: /admin/faq
export async function getAllFaqs({ signal } = {}) {
  const res = await apiClient.get(endpoints.base, { signal });
  return res.data; // { statusCode, success, message, data: [...] }
}

// POST: /admin/faq   BODY: { question, answer, status }
export async function addFaq({ question, answer, status }, { signal } = {}) {
  const payload = {
    question: String(question || "").trim(),
    answer: String(answer || "").trim(),
    status: normalizeStatus(status),
  };
  const res = await apiClient.post(endpoints.base, payload, { signal });
  return res.data; // { statusCode, success, message, data }
}

// PUT (partial): /admin/faq   BODY: { id, [question], [answer], [status] }
export async function updateFaqPartial(
  { id, question, answer, status },
  { signal } = {}
) {
  const payload = { id };
  if (typeof question !== "undefined") payload.question = String(question).trim();
  if (typeof answer !== "undefined") payload.answer = String(answer).trim();
  if (typeof status !== "undefined") payload.status = normalizeStatus(status);

  const res = await apiClient.put(endpoints.base, payload, { signal });
  return res.data; // { statusCode, success, message, data }
}

// DELETE: /admin/faq   BODY: { id }
export async function deleteFaq({ id }, { signal } = {}) {
  const res = await apiClient.delete(endpoints.base, {
    signal,
    data: { id },
  });
  return res.data;
}
